module.exports = __webpack_public_path__ + "img/sur-mesure.682375ea.png";